import { SkuSearchResult } from '../../API';
import { listSkuSearch } from '../../graphql/queries';
import { logger } from '../../utils/logger';
import { fetchGraphQLRequest } from './clients/graphqlClient';

/**
 * Searches for an ASIN or part number across the product hierarchy via GraphQL.
 */
export const searchSkuAPI = async (searchTerm: string): Promise<SkuSearchResult[]> => {
  const normalized = searchTerm.trim().toUpperCase();

  logger.info('skuSearchService: Searching', { searchTerm: normalized });

  const response = await fetchGraphQLRequest<{ listSkuSearch: { data: SkuSearchResult[] } }>({
    query: listSkuSearch,
    variables: { searchTerm: normalized },
    requestName: 'listSkuSearch',
    requestType: 'query',
  });

  const results = response.listSkuSearch?.data ?? [];
  logger.info('skuSearchService: Search completed', { resultCount: results.length });

  return results;
};
